// extracted by mini-css-extract-plugin
export var bounce = "_nj-1";
export var generatingText = "_nj-6";
export var lightning = "_nj-4";
export var popup = "_nj-5";
export var progressBar = "_nj-7";
export var progressFill = "_nj-8";
export var progressShimmer = "_nj-9";
export var progressText = "_nj-a";
export var shimmer = "_nj-3";
export var uploadIcon = "_nj-0";
export var uploadingText = "_nj-2";